"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));
require("antd/lib/badge/style");
var _badge = _interopRequireDefault(require("antd/lib/badge"));
require("antd/lib/radio/style");
var _radio = _interopRequireDefault(require("antd/lib/radio"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _antdMaskInput = _interopRequireDefault(require("antd-mask-input"));
var _utils = require("../../../utils");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _ = require("../..");
var _PatientInfoCard = require("../PatientInfoCard");
var _phoneNumber = require("../../../utils/phone-number.utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var UsaStates = _utils.UsaStatesUtils.UsaStates;
var phoneValidator = (0, _utils.phoneValidator)();
var Sex = _utils.GenderUtils.Sex;
var locationWarning = function locationWarning(location) {
  return "Warning: Ensure this patient\u2019s clinicians are licensed to practice in ".concat(location, ". If they are not, the patient must be rematched to new clinician(s). ");
};
var locationError = function locationError() {
  var locationName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'country';
  return "Monument does not provide medical service in this ".concat(locationName, ". You will need to cancel their therapy subscription and unmatch them from clinicians if you change their ").concat(locationName, ".");
};
var isActive = function isActive(value, activeUSAStates) {
  return !value || (0, _lodash.isEmpty)(activeUSAStates) || activeUSAStates.includes(value);
};
var stateSelectionRequired = 'Please enter state or select another country';
var isSameValue = function isSameValue(oldValue, fieldValue) {
  return fieldValue ? oldValue === fieldValue : false;
};
var PersonalInfoFormContent = function PersonalInfoFormContent(_ref) {
  var _patient$address, _patient$address2, _patient$address3, _patient$address4, _patient$address5, _patient$address6;
  var loading = _ref.loading,
    onSubmit = _ref.onSubmit,
    form = _ref.form,
    patient = _ref.data,
    personalInfoRequired = _ref.personalInfoRequired;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var isSuperAdminView = (0, _utils.isSuperAdmin)(user);
  var getFieldDecorator = form.getFieldDecorator,
    getFieldValue = form.getFieldValue;
  var stateValue = getFieldValue('state');
  var countryValue = getFieldValue('countryCode');
  var hasSameCountry = isSameValue((_patient$address = patient.address) === null || _patient$address === void 0 ? void 0 : _patient$address.countryCode, countryValue);
  var hasSameState = isSameValue((_patient$address2 = patient.address) === null || _patient$address2 === void 0 ? void 0 : _patient$address2.state, countryValue);
  var showStateSelector = (0, _react.useMemo)(function () {
    return countryValue === _utils.US_COUNTRY_CODE;
  }, [countryValue]);
  var ACCEPT_TYPES = [].concat(_toConsumableArray(_utils.ACCEPT_IMAGE_TYPES), _toConsumableArray(_utils.ACCEPT_PDF_TYPES));
  var imageValidators = [(0, _.maxImageSizeValidator)(20, 'Please use ID image with size less than 20 Mb'), (0, _.isAllowedTypeValidator)(ACCEPT_TYPES, function (file, fileType) {
    return (0, _.composeAcceptedFileTypesText)(ACCEPT_TYPES, fileType);
  })];
  var _useActiveUSAStates = (0, _utils.useActiveUSAStates)({
      includeCareSignupFreezed: true
    }),
    activeUSAStates = _useActiveUSAStates.activeUSAStates;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (err) {
        return;
      }
      var dto = _objectSpread(_objectSpread({}, (0, _lodash.pick)(values, ['firstName', 'middleName', 'lastName', 'suffix', 'sex', 'pronoun', 'insuranceSecondaryPay', 'preferredName'])), {}, {
        height: Number(values.height) || null,
        weight: Number(values.weight) || null,
        birthDate: (0, _utils.getISOStringDate)(values.dateOfBirth),
        phoneNumber: values.phone,
        address: {
          homeAddress: values.address,
          homeAddressLineTwo: values.address2,
          city: values.city,
          state: values.state,
          countryCode: values.countryCode,
          zipCode: values.zipCode
        }
      });
      var _ref2 = values.upload ? values.upload : [],
        _ref3 = _slicedToArray(_ref2, 1),
        file = _ref3[0];
      onSubmit({
        dto: dto,
        file: file
      });
    });
  };
  var phoneValidationDetails = (0, _phoneNumber.phoneNumberSMSCompatibilityDetails)({
    phoneSmsCompatible: patient.phoneSmsCompatible,
    phoneDeliveryPreference: patient.phoneDeliveryPreference,
    phoneType: patient.phoneType,
    phoneStatus: patient.phoneStatus
  });
  return /*#__PURE__*/_react.default.createElement(_PatientInfoCard.PatientInfoCard, {
    title: "Personal Info"
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    layout: "vertical",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('firstName', {
    initialValue: patient.firstName,
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter a first name'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "First Name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('middleName', {
    initialValue: patient.middleName
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Middle name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('lastName', {
    initialValue: patient.lastName,
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter a last name'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Last name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('suffix', {
    initialValue: patient.suffix
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Suffix",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label material-form-item"
  }, getFieldDecorator('dateOfBirth', {
    initialValue: patient.birthDate ? _momentTimezone.default.utc(patient.birthDate) : null,
    rules: [{
      type: 'object',
      required: personalInfoRequired,
      message: 'Please enter a valid date of birth'
    }]
  })( /*#__PURE__*/_react.default.createElement(_.DatePicker, {
    size: "large"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ant-input-group-addon permanent-open"
  }, "Date of birth")), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Sex"
  }, getFieldDecorator('sex', {
    initialValue: patient.sex,
    rules: [{
      required: personalInfoRequired,
      message: 'Please select sex'
    }]
  })( /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
    size: "large"
  }, Object.entries(Sex).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      label = _ref5[0],
      value = _ref5[1];
    return /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: label,
      value: value
    }, label);
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('preferredName', {
    initialValue: patient.preferredName,
    rules: []
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Preferred name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('pronoun', {
    initialValue: patient.pronoun,
    rules: []
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Pronouns",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('weight', {
    initialValue: patient.weight
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "number",
    addonAfter: "Weight",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('height', {
    initialValue: patient.height
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "number",
    addonAfter: "Height",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('phone', {
    initialValue: patient.phoneNumber,
    getValueFromEvent: function getValueFromEvent(e) {
      var val = e.target.value;
      return val && "".concat(val).replace(/[()\s-\W_]/g, '').slice(0, 10);
    },
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter a valid phone number'
    }, {
      validator: phoneValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_antdMaskInput.default, {
    mask: "(111) 111-1111",
    name: "phone",
    placeholder: "(123) 456-7890",
    size: "large",
    addonAfter: "Phone",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    },
    className: "phone-masked-input",
    addonBefore: phoneValidationDetails ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: phoneValidationDetails.description
    }, /*#__PURE__*/_react.default.createElement(_badge.default, {
      status: phoneValidationDetails.status,
      text: phoneValidationDetails.message,
      style: {
        marginRight: '10px'
      }
    })) : null
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('address', {
    initialValue: patient.address && patient.address.homeAddress,
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter home address'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Address",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('address2', {
    initialValue: patient.address && patient.address.homeAddressLineTwo
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Address 2",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('city', {
    initialValue: patient.address && patient.address.city,
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter City'
    }, {
      min: 2,
      message: 'City must contain at least 2 characters'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "City",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 24
  }, isSuperAdminView ? /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Country",
    validateStatus: hasSameCountry ? '' : 'warning',
    help: hasSameCountry ? '' : countryValue !== _utils.US_COUNTRY_CODE ? countryValue && locationError() : ''
  }, getFieldDecorator('countryCode', {
    initialValue: (_patient$address3 = patient.address) === null || _patient$address3 === void 0 ? void 0 : _patient$address3.countryCode
  })( /*#__PURE__*/_react.default.createElement(_.LegacySelectInput, {
    name: "countryCode",
    placeholder: "Country",
    showSearch: true,
    size: "large",
    options: _utils.AVAILABLE_COUNTRY_CODES.map(function (code) {
      return {
        key: code,
        value: code,
        label: (0, _utils.getFullCountryName)(code)
      };
    })
  }))) : /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('countryCode', {
    initialValue: (_patient$address4 = patient.address) === null || _patient$address4 === void 0 ? void 0 : _patient$address4.countryCode
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Country",
    disabled: true,
    size: "large"
  }))))), /*#__PURE__*/_react.default.createElement(_row.default, null, showStateSelector && /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 11
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "State",
    validateStatus: hasSameState ? '' : 'warning',
    help: hasSameState ? '' : isActive(stateValue, activeUSAStates) ? stateValue ? locationWarning(stateValue) : stateSelectionRequired : locationError('state')
  }, getFieldDecorator('state', {
    initialValue: patient.address && patient.address.state,
    rules: [{
      required: !stateValue,
      message: stateSelectionRequired
    }]
  })( /*#__PURE__*/_react.default.createElement(_.LegacySelectInput, {
    name: "state",
    placeholder: "State",
    showSearch: true,
    size: "large",
    dropdownClassName: "RegisterPatientFormSelectDropdown",
    options: UsaStates.map(function (st) {
      return {
        value: st.abbreviation,
        key: st.abbreviation,
        label: st.name
      };
    })
  })))), !isSuperAdminView && ((_patient$address5 = patient.address) === null || _patient$address5 === void 0 ? void 0 : _patient$address5.countryCode) && /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 11
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('state', {
    initialValue: (_patient$address6 = patient.address) === null || _patient$address6 === void 0 ? void 0 : _patient$address6.state
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "State",
    disabled: true,
    size: "large"
  })))), /*#__PURE__*/_react.default.createElement(_col.default, {
    offset: showStateSelector ? 2 : 0,
    span: showStateSelector ? 11 : 24
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "floating-label"
  }, getFieldDecorator('zipCode', {
    initialValue: patient.address && patient.address.zipCode,
    rules: [{
      required: personalInfoRequired,
      message: 'Please enter a zip code'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Zip code",
    size: "large"
  }))))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: 'Secondary insurance payer',
    className: "floating-label"
  }, getFieldDecorator('insuranceSecondaryPay', {
    initialValue: patient.insuranceSecondaryPay
  })( /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    value: true
  }, "Yes"), /*#__PURE__*/_react.default.createElement(_radio.default, {
    value: false
  }, "No")))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "ID card"
  }, getFieldDecorator('upload', {
    valuePropName: 'fileList',
    rules: [{
      required: false,
      message: 'Please upload ID card'
    }]
  })( /*#__PURE__*/_react.default.createElement(_.ImageUploader, {
    imageId: patient.image,
    validators: imageValidators,
    accept: ACCEPT_TYPES.join(',')
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    size: "large",
    block: true,
    loading: loading
  }, "Save changes"))));
};
var _default = _form.default.create()(PersonalInfoFormContent);
exports.default = _default;